import AbstractCalls from "./AbstractCalls";

class RegistrationCalls extends AbstractCalls {
  create(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/create");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  update(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/update");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  getByRace(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/getByRace");
    return AbstractCalls.get(cmdUri, body, options);
  }

  delete(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/delete");
    return AbstractCalls.delete(cmdUri, dtoIn, options);
  }

  forceDelete(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/forceDelete");
    return AbstractCalls.delete(cmdUri, dtoIn, options);
  }

  listActive(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/listActive");
    return AbstractCalls.get(cmdUri, body, options);
  }

  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  getStartList(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/getStartList");
    return AbstractCalls.get(cmdUri, body, options);
  }

  submit(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/submit");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  submitMarket(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/submitMarket");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  updateProfile(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/updateProfile");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  sudoSetState(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/sudoSetState");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  sudoSetPaymentState(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/sudoSetPaymentState");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  sudoSetFeeState(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/sudoSetFeeState");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  addVoucher(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/addVoucher");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  retryPayment(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/retryPayment");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  listLogs(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/listLogs");
    return AbstractCalls.get(cmdUri, body, options);
  }

  assignNextStartNumber(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/assignNextStartNumber");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  setStartNumber(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/setStartNumber");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  search(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/search");
    return AbstractCalls.get(cmdUri, body, options);
  }

  accredit(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/accreditation/accredit");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  revokeAccreditation(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "registration/accreditation/revoke");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }
}

export default new RegistrationCalls();
